import { weixin, tenvideo, env } from '@tencent/vft-common';

// 隐藏分享按钮
export function hideShare() {
  if (weixin.isWeiXin()) {
    weixin.hideOptionMenu();
  } else if (tenvideo.isTenvideo()) {
    tenvideo.hideMore();
  } else if (env.isMqq) {
    if (window.mqq) {
      hideMqqShare();
    } else {
      $.getScript('https://open.mobile.qq.com/sdk/qqapi.js?_bid=152', hideMqqShare);
    }
  }
}

function hideMqqShare() {
  mqq.ui.setWebViewBehavior({
    actionButton: 0,
  });
  // 隐藏底部导航条：
  mqq.ui.setWebViewBehavior({
    bottomBar: false,
  });
}
